import * as S from './styles'
import React from 'react'
import { AllHTMLAttributes } from 'react'

export type TextAreaProps = {
  onInputChange?: (value: string) => void
  label?: string
  initialValue?: string
  icon?: React.ReactNode
  disabled?: boolean
  error?: string | false
  bgColor?: 'mainBg' | 'white' | 'lightestGray'
  required?: boolean
  outline?: boolean
  outlineColor?: 'primary' | 'gray'
  dataTestId?: string | number
} & AllHTMLAttributes<HTMLTextAreaElement>

const TextArea: React.ForwardRefRenderFunction<
  HTMLTextAreaElement,
  TextAreaProps
> = (
  {
    label,
    name,
    error,
    disabled = false,
    onInputChange,
    style,
    bgColor = 'white',
    required = false,
    outline,
    outlineColor,
    dataTestId,
    ...props
  }: TextAreaProps,
  ref
) => {
  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.currentTarget.value

    !!onInputChange && onInputChange(newValue)
    !!props.onChange && props.onChange(e)
  }

  return (
    <S.Wrapper style={style} disabled={disabled} error={!!error}>
      {!!label && (
        <S.Label htmlFor={name}>
          {label}
          {required ? <S.Asterisk>*</S.Asterisk> : ''}
        </S.Label>
      )}
      <S.InputWrapper>
        <S.Input
          onChange={onChange}
          disabled={disabled}
          name={name}
          value={props.value}
          bgColor={bgColor}
          ref={ref}
          {...(label ? { id: name } : {})}
          rows={props.rows}
          cols={props.cols}
          placeholder={props.placeholder}
          aria-label={props['aria-label']}
          outline={outline}
          outlineColor={outlineColor}
          onBlur={props.onBlur}
          defaultValue={props.defaultValue}
          data-testid={dataTestId}
        />
      </S.InputWrapper>
      {!!error && <S.Error>{error}</S.Error>}
    </S.Wrapper>
  )
}

export default React.forwardRef(TextArea)
